import Vue from "vue";

export const AlertBus = new Vue();
